import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
import * as moment from 'moment/moment';
import { DateService } from '@app/shared/services/date.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sinister-list',
  templateUrl: './sinister-list.component.html',
  styleUrls: ['./sinister-list.component.scss']
})
export class SinisterListComponent implements OnInit {

  /* Datepicker */

  public dateStart : string = moment().subtract(30, 'days').format('DD/MM/YYYY').split('T')[0];
  public dateEnd : string = moment().format('DD/MM/YYYY').split('T')[0];
  public dateStartChanged : Subject<string> = new Subject<string>();
  public dateEndChanged : Subject<string> = new Subject<string>();

  /* Filters */

  public status: number = -1;

  /* List */

  public loadingStatus: boolean = true;
  public noResult: boolean = false;
  public sinisters: Array<any> = [];

  /* Sinister state */

  public boundSinister : any = {
    id: 0,
    state: 0
  };

  constructor(
    private titleService: TitleService,
    private menu: MenuService,
    public stateOfCarService: StateOfCarService,
    private dateService: DateService
  ) {
    this.dateStartChanged
    .subscribe(model => {
      this.dateStart = model;
      sessionStorage.setItem('SinisterFilterDateStart', this.dateStart);
      this.updateSinisters();
    });

    this.dateEndChanged
    .subscribe(model => {
      this.dateEnd = model;
      sessionStorage.setItem('SinisterFilterDateEnd', this.dateEnd);
      this.updateSinisters();
    });
  }

  retrieveFilters() {
    this.dateStart = ('SinisterFilterDateStart' in sessionStorage) ? sessionStorage.getItem('SinisterFilterDateStart') : this.dateStart;
    this.dateEnd = ('SinisterFilterDateEnd' in sessionStorage) ? sessionStorage.getItem('SinisterFilterDateEnd') : this.dateEnd;
    this.status = ('SinisterFilterStatus' in sessionStorage) ? parseInt(sessionStorage.getItem('SinisterFilterStatus'), 10) : this.status;
  }

  ngOnInit() {
    this.titleService.setTitle(`Liste des alertes / VOP`);
    this.menu.setMenuState('dashboard', 'alert', 'alert');
    this.retrieveFilters();
    this.initSinisters(0);
  }

  changeStatus(status) : void {
    this.status = status;
    sessionStorage.setItem('SinisterFilterStatus', this.status.toString());
    this.updateSinisters();
  }

  onDateChange(start, date) : void {
    if (start === true) {
      this.dateStartChanged.next(date);
    } else {
      this.dateEndChanged.next(date);
    }
  }

  initSinisters(next) {
    if (next === 390) {
      return;
    }
    this.stateOfCarService.updateStateOfCarByDates(
      moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
      moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
      this.status
    ).then((res) => {
      if (res.length === 0) {
        this.noResult = true;
        this.dateStart = moment().subtract(next + 30, 'days').format('DD/MM/YYYY').split('T')[0];
        this.dateEnd = moment().subtract(next, 'days').format('DD/MM/YYYY').split('T')[0];
        this.initSinisters(next + 30);
      } else {
        this.loadingStatus = false;
        this.noResult = false;
        res = this.dateService.convertAlltoLocal(res);
        this.sinisters = res;
      }
    });
  }

  updateSinisters() {
    this.loadingStatus = true;
    this.stateOfCarService.updateStateOfCarByDates(
      moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
      moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
      this.status
    ).then((res) => {  
      this.loadingStatus = false;
      if (this.stateOfCarService.stateOfCarCount === 0) {
        this.noResult = true;
      } else {
        res = this.dateService.convertAlltoLocal(res);
        this.sinisters = res;
        this.noResult = false;
      }
    });
  }

  bindSinister(sinister) {
    this.boundSinister.id = sinister.idStateOfCar;
    this.boundSinister.status = sinister.state;
  };

  onSinisterStatusChanged(newState) {
    this.stateOfCarService.stateOfCars.find((o : any, i) => {
      if (o.idStateOfCar === this.boundSinister.id) {
        this.stateOfCarService.stateOfCars[i].state = parseInt(newState, 10);
      }
    });
  };

}
